import { useEffect, useState } from 'react';
import { Alert, Button, Form, Select } from 'antd';
import {
  getOneTimeCallChoices,
  OneTimeCallChoices as Choices,
} from '@/apis/shipment';

export default function OneTimeCallChoices({
  checkTokenExpiry,
}: {
  checkTokenExpiry: () => string;
}) {
  const [choices, setChoices] = useState<Choices>({ contacts: [], agents: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    getOneTimeCallChoices(checkTokenExpiry())
      .then((data) => {
        if (active) setChoices(data);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [checkTokenExpiry, retry]);
  return (
    <>
      {error && (
        <Alert
          type='error'
          message='Saved call choices could not be loaded.'
          action={<Button onClick={() => setRetry(retry + 1)}>Retry</Button>}
        />
      )}
      <Form.Item name='call_contact_id' label='Saved phone contact'>
        <Select
          className='custom-dd one-time-call-choice'
          allowClear
          showSearch
          loading={loading}
          optionFilterProp='label'
          placeholder='Use the recipients below'
          notFoundContent='No saved phone contacts'
          options={choices.contacts.map((c) => ({
            value: c.id,
            label: c.name,
          }))}
        />
      </Form.Item>
      <Form.Item name='call_agent_id' label='Outbound agent'>
        <Select
          className='custom-dd one-time-call-choice'
          allowClear
          showSearch
          loading={loading}
          optionFilterProp='label'
          placeholder='Use the default agent'
          notFoundContent='No saved outbound agents'
          options={choices.agents.map((a) => ({ value: a.id, label: a.name }))}
        />
      </Form.Item>
      <p className='zl-para-400-12 color-5e'>
        Include the order number, requested pickup time and time zone, and
        confirmation email in your message. An accepted request can still be
        pending confirmation.
      </p>
    </>
  );
}
